import { global } from '../constants';

export const data = {
	whychooseus: {
		title: 'Why Choose Us',
		subtitle: 'Trusted Partner for High-Value Asset Solutions',
		description: {
			short:
				'We specialize in secure, end-to-end services for clients who demand discretion, reliability, and excellence.',
			long: "With a proven track record in handling valuable and sensitive assets, we deliver integrated solutions backed by global reach, expert compliance, and advanced protection protocols. Whether you're moving, storing, or managing high-value resources, we operate with precision, integrity, and your peace of mind at the core.",
		},
	},

	whatwedo: {
		title: 'What We Do!',
		subtitle: 'Specialized Secure Logistics Solutions',
		description:
			'We provide secure, compliant, and efficient services tailored to the movement, protection, and storage of high-value assets — trusted by institutions, traders, and private clients worldwide.',
		works: [
			{
				icon: global.icons2 + 'pic1.png',
				serial: '01',
				title: 'Secure Ground Transport',
				description:
					'Fully monitored and professionally escorted ground logistics for high-value assets with end-to-end control.',
			},
			{
				icon: global.icons2 + 'pic2.png',
				serial: '02',
				title: 'Secure Storage & Vaulting',
				description:
					'Short- and long-term storage in high-security vaults, designed for precious items requiring controlled environments and restricted access.',
			},
			{
				icon: global.icons2 + 'pic3.png',
				serial: '03',
				title: 'Air Charter & Express Logistics',
				description:
					'Priority air solutions for urgent and sensitive cargo, backed by tracking, clearance, and global coordination.',
			},
		],
	},
	estimation: {
		background: '/assets/images/background/bg-9.jpg',
		title: 'Our Strengths',
		subtitle: 'Tailored solutions for your valuable assets',
		description:
			'Our services go beyond simple delivery—we offer bespoke handling, security, and real-time transparency for your high-value shipments and assets.',
		solutions: [
			{
				serial: '01',
				title: 'Specialized Handling',
				subtitle:
					'We handle your valuables with the highest care and expertise, ensuring secure and professional transportation at every step.',
				url: '/about-us',
			},
			{
				serial: '02',
				title: 'Secure Storage Facilities',
				subtitle:
					'Need a safe space for your items? Our secure and climate-controlled storage ensures your assets are protected until you’re ready.',
				url: '/services/storage',
			},
			{
				serial: '03',
				title: 'Simple & Reliable Tracking',
				subtitle:
					'Track your shipment effortlessly from dispatch to delivery. We ensure you stay informed at every step with timely updates.',
				url: '/track-shipment',
			},
		],
	},
	services: {
		title: 'All services',
		subtitle: 'Trusted For Our Services',
		description:
			'Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the when an printer took.',
		services: [
			{
				title: 'Air Freight',
				serial: '01',
				description:
					'Our aim is to optimize and improve your supply chain so that we can give you the best service.',
			},
			{
				title: 'Road Freight',
				serial: '02',
				description:
					'Our aim is to optimize and improve your supply chain so that we can give you the best service.',
			},
			{
				title: 'Ocean Freight',
				serial: '03',
				description:
					'Our aim is to optimize and improve your supply chain so that we can give you the best service.',
			},
			{
				title: 'Rail Freight',
				serial: '04',
				description:
					'Our aim is to optimize and improve your supply chain so that we can give you the best service.',
			},
			{
				title: 'Warehousing',
				serial: '05',
				description:
					'Our aim is to optimize and improve your supply chain so that we can give you the best service.',
			},
			{
				title: 'Project Cargo',
				serial: '06',
				description:
					'Our aim is to optimize and improve your supply chain so that we can give you the best service.',
			},
		],
	},
	testimonials: {
		title: 'Testimonials',
		subtitle: 'What Our Clients Say',
		quotes: [
			{
				image: global.testim + 'pic1.jpg',
				quote:
					'Exceptional service from start to finish. Their professionalism and attention to detail made us feel confident entrusting them with our high-value shipments.',
				name: 'Jonathan Reyes',
				designation: 'Operations Manager, Aurum Holdings',
			},
			{
				image: global.testim + 'pic2.jpg',
				quote:
					'We’ve worked with several logistics partners, but none match the secure handling and timely delivery this team offers. Highly recommended for sensitive cargo.',
				name: 'Sophia Kim',
				designation: 'Security Director, Noble Vaults Inc.',
			},
			{
				image: global.testim + 'pic3.jpg',
				quote:
					'The level of transparency and communication is outstanding. We always know where our valuable items are—every step of the way.',
				name: 'Mark DeSilva',
				designation: 'Supply Chain Lead, Orion Metals',
			},
			{
				image: global.testim + 'pic4.jpg',
				quote:
					'From secure transport to private storage, they’ve provided us with complete peace of mind. A trusted partner for our global operations.',
				name: 'Emily Davenport',
				designation: 'VP Logistics, Crown Asset Management',
			},
		],
		clients: [
			global.logo + 'w1.png',
			global.logo + 'w2.png',
			global.logo + 'w3.png',
			global.logo + 'w4.png',
			global.logo + 'w5.png',
			global.logo + 'w1.png',
			global.logo + 'w2.png',
			global.logo + 'w3.png',
			global.logo + 'w4.png',
			global.logo + 'w5.png',
		],
	},
	approch: {
		title: 'Company Approach',
		subtitle: 'Reliable Logistic & Transport Solutions',
		yearsOfExperience: '18',
		solutions: [
			{
				icon: global.icons + 'c-pic1.png',
				count: '85',
				title: 'Professional Staff',
			},
			{
				icon: global.icons + 'c-pic1.png',
				count: '250',
				title: 'On Time Delievery',
			},
			{
				icon: global.icons + 'c-pic1.png',
				count: '30',
				title: 'Operating Countries',
			},
		],
	},

	booking: {
		background: global.booking + 'bg-map.png',
		image: global.booking + 'pic2.png',
		imageBack: global.booking + 'truck-book.png',
		title: 'Request A Quote',
		subtitle: 'Booking For Product Transformation',
		description:
			'Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the when an printer took.',
		form: {
			quote: global.booking + 'icon1.png',
			track: global.booking + 'icon2.png',
		},
	},

	blogs: {
		title: 'Our Blogs',
		subtitle: 'Recent news & events',
		description:
			'Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the when an printer took.',
		blogs: [
			{
				day: '05',
				month: 'Aug',
				title: 'Go beyond logistics, make the world go round and revolutionize',
				description:
					'New chip traps clusters of migrating are tumor cells  asperiortenetur, blanditiis odit.',
			},
			{
				day: '07',
				month: 'Aug',
				title: 'Go beyond logistics, make the world go round and revolutionize',
				description:
					'New chip traps clusters of migrating are tumor cells  asperiortenetur, blanditiis odit.',
			},
			{
				day: '09',
				month: 'Aug',
				title: 'Go beyond logistics, make the world go round and revolutionize',
				description:
					'New chip traps clusters of migrating are tumor cells  asperiortenetur, blanditiis odit.',
			},
		],
	},
	intro: {
		img: '/assets/images/affiliations.png',
		tagline: "TRUSTED BY THE WORLD'S FINEST",
		heading: 'Strategic global affiliations with leading organizations',
		description:
			'We are proud to be affiliated with some of the most prestigious organizations in secure logistics and transportation industry.',
	},
};
